import React from "react";
import { FaPlus } from "react-icons/fa";
import AssetCardSkeleton, {
  AssetCard,
  formatNumber,
  formatRoundedCHF,
  truncateToTwoDecimals,
} from "../../../../../utility/helper";

const OverviewSection = ({
  isLoading,
  allAssetsData,
  handleOptionSelect,
  handleIconClick,
}) => {
  return (
    <div className="w-full pl-4">
      <h2 className="text-2xl font-semibold text-lightPrimary mb-3 mt-5 text-black dark:text-primary-gradient inline-block">
        Overview
      </h2>

      {isLoading ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 md:grid-cols-2 xl:gap-x-12 xl:gap-y-10 w-full">
          {Array.from({ length: 3 }).map((_, idx) => (
            <AssetCardSkeleton key={idx} />
          ))}
        </div>
      ) : (
        allAssetsData?.length > 0 && (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 md:grid-cols-2 gap-6 xl:gap-x-12 xl:gap-y-10 w-full">
            {allAssetsData?.map((item, idx) => (
              <AssetCard
                key={idx}
                name={item?.asset_name}
                value={
                  item?.asset_type === 6
                    ? formatRoundedCHF(item?.current_value)
                    : formatNumber(
                        truncateToTwoDecimals(Number(item?.current_value))
                      )
                }
                roi={
                  item?.asset_type === 2
                    ? item?.roi * 100
                    : item?.asset_type === 1 || item?.asset_type === 6
                    ? "--"
                    : item?.roi 
                }
                legacy={item?.legacy}
                asset_type={item?.asset_type}
                isSold={item?.is_sold || false}
                icon={item?.icon}
                onClick={() => handleOptionSelect(item?.asset_type, item?.id)}
              />
            ))}
          </div>
        )
      )}

      {allAssetsData?.length === 0 && !isLoading && (
        <div className="text-center text-2xl flex justify-center flex-col items-center space-y-12 h-[calc(100vh-28rem)]">
          <div className="font-semibold text-lightPrimary dark:text-primary-gradient">
            Welcome! Click below to build your wealth
          </div>
          <button
            onClick={handleIconClick}
            className="text-2xl font-bold bg-[radial-gradient(circle_at_10%_10%,rgb(237,237,237),#9e9e9e,#9e9e9e,#9e9e9e)] rounded-md border border-lightPrimary dark:button-primary-gradient rounded-md"
          >
            <FaPlus fontSize={40} className="p-2 dark:text-black" />
          </button>
        </div>
      )}
    </div>
  );
};

export default OverviewSection;
